import credits from "./credits.component";
import creditsUrls from "./credits.urls";
import CreditsTransforms from "./credits.transforms";

const creditsModule = angular
  .module("app.components.credits", [])
  .component("creditsPage", credits)
  .service("CreditsTransforms", CreditsTransforms)
  .config(creditsUrls);

export default creditsModule;



// WEBPACK FOOTER //
// ./src/pages/credits/credits.module.js